<template>
  <div class="teilnehmer-verlauf">
    <div class="teilnehmer-verlauf__header">
      <History :size="18" class="mr-2" style="color: #3699ff" />
      <h6 class="mb-0">Verlauf – {{ teilnehmer.name }}</h6>
      <span
        class="teilnehmer-verlauf__close ml-auto"
        title="Verlauf schließen"
        v-b-tooltip.hover
        @click="$emit('close')"
      >
        <X :size="18" />
      </span>
    </div>

    <b-skeleton-table v-if="isLoading" :rows="3" :columns="1"></b-skeleton-table>
    <TeilnehmerChangeHistory v-else :data="verlaufData"></TeilnehmerChangeHistory>
  </div>
</template>

<script>
import TeilnehmerChangeHistory from './teilnehmer-change-history.vue';
import { getTeilnehmerHistory } from '@/core/vorgaenge/teilnehmer-passdaten.service';
import { History, X } from 'lucide-vue';

export default {
  name: 'TeilnehmerVerlauf',
  components: { TeilnehmerChangeHistory, History, X },
  props: {
    vorgangId: { type: Number, required: true },
    teilnehmer: { type: Object, required: true },
  },
  data() {
    return {
      isLoading: false,
      verlaufData: {},
    };
  },
  watch: {
    // Beim Wechsel des ausgewählten Teilnehmers wird der Verlauf neu geladen,
    teilnehmer: {
      handler() {
        this.loadVerlauf();
      },
      immediate: true,
    },
  },
  methods: {
    async loadVerlauf() {
      this.verlaufData = {};
      this.isLoading = true;
      try {
        this.verlaufData = (await getTeilnehmerHistory(this.vorgangId, this.teilnehmer.nummer)) || {};
      } catch (error) {
        console.error('Fehler beim Laden des Verlaufs:', error);
        this.toast('Fehler beim Laden des Verlaufs', { variant: 'danger' });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.teilnehmer-verlauf {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px 24px;
  height: 100%;
  background: #fff;
  box-shadow: 0px 1px 3px 0px #0000001a;
}
.teilnehmer-verlauf__header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.teilnehmer-verlauf__close {
  color: #b5b5c3;
  cursor: pointer;
  line-height: 1;

  &:hover {
    color: #3699ff;
  }
}
</style>
